import { joinShare } from '@jotta/grpc-connect-openapi/sharingQuery'
import { useMutation } from '@connectrpc/connect-query'
import { authTransport } from '../transport'

export function useJoinShare() {
  return useMutation(joinShare, { transport: authTransport })
}
